var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCertificateCompletion1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1977",
    "data-name": "Rectangle 1977",
    width: 24,
    height: 24,
    transform: "translate(948 461)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6250",
    "data-name": "Group 6250",
    transform: "translate(-948 -461)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6782",
    "data-name": "Path 6782",
    d: "M960.836,461.028a12,12,0,0,0-12.807,12.827c.441,6.353,6.053,11.145,13.054,11.145H967a5.005,5.005,0,0,0,5-5v-6.66a12.209,12.209,0,0,0-11.164-12.312Zm5.864,9.684-6.793,6.707a2,2,0,0,1-2.823,0l-3.784-3.7a1,1,0,1,1,1.4-1.43l3.793,3.707,6.806-6.7a1,1,0,0,1,1.4,1.424Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateCompletion1);
export default __webpack_public_path__ + "static/media/certificate-completion1.7b78435b72b8cbc257c959705a45dcc8.svg";
export { ForwardRef as ReactComponent };